import { API } from '../helpers/fetcher'

export const getJWT = async (amount, billingAddress, cardId) =>
  API.post('v1/transaction/card/cardinal-jwt', {
    amount,
    // pass billingAddress only in case new user card
    billingAddress: cardId ? undefined : billingAddress,
    cardId,
  })
